import { ArrowLeft, ArrowRight } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

function Introducao() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Introdução</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h2>O que é o iNOVACODE IMPRESSÃO?</h2>
          <span>
            O iNOVACODE IMPRESSÃO é uma plataforma de impressão e gravação de
            etiquetas, que permite a impressão simplificada de etiquetas RFID.
          </span>
          <span>
            Possuindo integrações avançadas, é a solução perfeita para reduzir
            custos na hora de utilizar a tecnologia RFID.
          </span>
          <span>
            Tendo a opção de realizar impressões em impressora comuns ou RFID.
          </span>
          <h2>O que esperar desta documentação?</h2>
          <span>
            A documentação do iNOVACODE IMPRESSÃO é um recurso essencial para
            todos os usuários que desejam aproveitar ao máximo as
            funcionalidades da nossa plataforma.
          </span>
          <span>
            Ela oferece um guia abrangente sobre como utilizar nossas
            ferramentas e serviços para a criação, impressão e gravação de
            etiquetas RFID.
          </span>
          <span>
            A plataforma oferece uma interface intuitiva e fácil de usar, que
            permite a criação e impressão de etiquetas de forma rápida e
            eficiente.
          </span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h2>Funcionamento do sistema</h2>
          <span>
            A seguir um fluxograma que descreve o funcionamento da plataforma.
          </span>
          <span>
            Onde mostra o usuário gerando o pedido de impressão com a quantidade
            de EPCs desejados e visual de etiqueta.
          </span>
          <span>
            Então o IMPRESSÃO WEB faz envio desses elementos para o módulo de
            impressão.
          </span>
          <span>
            Logo em seguida o módulo recebe os elementos e envia para a
            impressora.
          </span>
          <span>
            Após impresso, ocorre o cadastro do elemento na base de dados do
            usuário.
          </span>
          <img
            style={{ border: "1px solid #c2c2c2" }}
            src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/fluxo+impressao.png"
            width={1000}
          />
        </div>
      </div>

      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <ArrowLeft style={{ padding: 8 }} />
        <span>
          Navegue pelo menu a esquerda para saber como utilizar todas as funções
          do sistema.
        </span>
      </div>
    </div>
  );
}

function Etiquetas() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Sobre Etiquetas</h1>

      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                Todo usuário contará com pelo menos 1 etiqueta que será criada
                automaticamente ao criar a conta.
              </span>
              <span>
                O visual da primeira etiqueta será gerado pela plataforma, mas o
                usuário poderá alterar as informações.
              </span>

              <span>
                Caso o cliente já não tenha um ZPL pronto, o mesmo deve ser
                gerado pelo time de suporte ou impressão.
              </span>

              <span style={{ textDecoration: "underline" }}>
                Atenção: Sempre certifique que o exista uma etiqueta padrão
                definida antes de realizar qualquer impressão.
              </span>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ArrowLeft style={{ padding: 8 }} />
          <span>
            Navegue pelo menu a esquerda para acessar outros tópicos
            relacionados a "Etiquetas".
          </span>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function CriarEtiqueta() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Como criar uma etiqueta</h1>
      <span>
        Após criar o ZPL e coletar as informações de altura e largura da
        etiqueta em centimetros, siga os seguintes passos:
      </span>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h3>Passo 1:</h3>
          <span>
            No menu lateral esquerdo localize a sessão "Etiquetas" clique.
          </span>
          <img
            style={{ border: "1px solid #c2c2c2" }}
            src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/nova_etiqueta.png"
            width={1000}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h3>Passo 2:</h3>
          <span>No canto superior direito clique em "Criar Etiqueta".</span>
          <img
            style={{ border: "1px solid #c2c2c2" }}
            src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/nova_etiqueta2.png"
            width={1000}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h3>Passo 3:</h3>
          <span>
            Preencha com as informações necessarias e clique em "Criar".
          </span>
          <img
            style={{ border: "1px solid #c2c2c2" }}
            src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/nova_etiqueta3.png"
            width={1000}
          />
        </div>
      </div>
      <div style={{ borderBottom: "1px solid #c2c2c2", margin: 16 }} />
    </div>
  );
}

function EditarEtiqueta() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Como editar uma etiqueta</h1>

      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <h3>Passo 1:</h3>
            <span>
              No menu lateral esquerdo localize a sessão "Etiquetas" clique.
            </span>
            <img
              style={{ border: "1px solid #c2c2c2" }}
              src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/nova_etiqueta.png"
              width={1000}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <h3>Passo 2:</h3>
            <span>
              Ao localizar a etiqueta que deseja editar, clique em "Editar".
            </span>
            <img
              style={{ border: "1px solid #c2c2c2" }}
              src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/editar_etiqueta.png"
              width={1000}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <h3>Passo 3:</h3>
            <span>
              Preencha com as informações necessarias e clique em "Salvar".
            </span>
            <img
              style={{ border: "1px solid #c2c2c2" }}
              src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/editar_etiqueta2.png"
              width={1000}
            />
          </div>
        </div>
      </div>
      <div style={{ borderBottom: "1px solid #c2c2c2", margin: 16 }} />
    </div>
  );
}

function DefinirEtiquetaPadrao() {
  return (
    <div style={{ margin: 8 }}>
      <h1> Como definir uma etiqueta padrão</h1>
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <h3>Passo unico:</h3>
            <span>
              Na página de etiquetas localize a etiqueta que deseja definir como
              padrão e em "Padrão"
            </span>
            <span>
              A cor cinza em "Padrão" indica que a etiqueta é a padrão.
            </span>
            <span>
              As impressões só são possiveis quando há uma etiqueta padrão.
            </span>
            <img
              style={{ border: "1px solid #c2c2c2" }}
              src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/definir_padrao_etiqueta.png"
              width={1000}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ApagarEtiqueta() {
  return (
    <div style={{ margin: 8 }}>
      <h1> Como apagar uma etiqueta</h1>
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <h3>Passo unico:</h3>
            <span>
              Na página de etiquetas localize a etiqueta que deseja apagar e
              clique em "Apagar".
            </span>
            <img
              style={{ border: "1px solid #c2c2c2" }}
              src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/apagar_etiqueta.png"
              width={1000}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function RFW() {
  return (
    <div style={{ margin: 8 }}>
      <h1>O que significa RFW?</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                RFW é um comando informado no ZPL das etiquetas, que informa se
                a impressora que será usada é uma impressora que já possui
                gravação embutida (impressora RFID).
              </span>
              <span>
                Caso a etiqueta não possua o comando RFW, a gravação e
                conferencia de etiqueta será feita utilizando o módulo de
                impressão externo.
              </span>
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function VariaveisDeInformacoes() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Variaveis de Substituição</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                As variaveis de substituição são nomeclaturas que você irá
                utilizar no código ZPL da etiqueta.
              </span>
              <span>
                Cada variavel de substituição é um campo que será substituido
                com a informação do elemento a ser impresso, isto é, no visual
                da sua etiqueta.
              </span>
            </div>
          </div>
        </div>
        <div style={{ gap: 8, display: "flex", flexDirection: "column" }}>
          <h2>
            Variaveis Disponiveis - Impressão Avulsa / Impressão OF/REF /
            Impressão por Planilha
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <li>{"{ean} - será substituido pelo código."}</li>
              <li>
                {
                  "{eansemzero} - será substituido pelo código sem zeros a esquerda."
                }
              </li>
              <li>{"{sscc} - será substituido pelo código sscc."}</li>
              <li>{"{epc} - será substituido pelo EPC."}</li>
              <li>
                {
                  "{epc3final} - será substituido pelos 3 últimos caracteres do EPC."
                }
              </li>
              <li>
                {
                  "{epc6final} - será substituido pelos 6 últimos caracteres do EPC."
                }
              </li>
              <li>
                {"{epcsze} - será substituido pelo EPC sem zeros a esquerda."}
              </li>
              <li>{"{desc} - será substituido pela descrição."}</li>
              <li>{"{serial} - será substituido pelo serial."}</li>
              <li>{"{serial+1} - será substituido pelo serial + 1."}</li>
              <li>
                {
                  "{serialc2ze} - será substituido pelo serial completando com zeros a esquerda até 2 digitos."
                }
              </li>
              <li>
                {
                  "{serialc3ze} - será substituido pelo serial completando com zeros a esquerda até 3 digitos."
                }
              </li>
              <li>
                {
                  "{serialcze} - será substituido pelo serial completando com zeros a esquerda até 4 digitos."
                }
              </li>
              <li>
                {
                  "{serialc5ze} - será substituido pelo serial completando com zeros a esquerda até 5 digitos."
                }
              </li>
              <li>
                {
                  "{serialc6ze} - será substituido pelo serial completando com zeros a esquerda até 6 digitos."
                }
              </li>
              <li>
                {
                  "{serialc7ze} - será substituido pelo serial completando com zeros a esquerda até 7 digitos."
                }
              </li>
              <li>
                {
                  "{serialc8ze} - será substituido pelo serial completando com zeros a esquerda até 8 digitos."
                }
              </li>
              <li>
                {"{info1} - será substituido pela informação complementar 1."}
              </li>
              <li>
                {"{info2} - será substituido pela informação complementar 2."}
              </li>
              <li>
                {"{info3} - será substituido pela informação complementar 3."}
              </li>
              <li>
                {"{info4} - será substituido pela informação complementar 4."}
              </li>
              <li>
                {"{n_impressao} - será substituido pelo número da impressão."}
              </li>
              <li>{"{data-hora} - será substituido pela data e hora."}</li>
              <li>{"{id_item} - será substituido pelo id do item."}</li>
              <li>{"{id_externo} - será substituido pelo id externo."}</li>
              <li>{"{data} - será substituido pela data."}</li>
              <li>{"{data2} - será substituido pela data AAAAMMDD."}</li>
            </div>
          </div>
        </div>
        <div style={{ gap: 8, display: "flex", flexDirection: "column" }}>
          <h2>Variaveis Disponiveis - Ordem de Impressão</h2>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <li>{"{epc} - será substituido pelo EPC."}</li>
              <li>
                {"{info1} - será substituido pela informação complementar 1."}
              </li>
              <li>
                {"{info2} - será substituido pela informação complementar 2."}
              </li>
              <li>
                {"{info3} - será substituido pela informação complementar 3."}
              </li>
              <li>
                {"{info4} - será substituido pela informação complementar 4."}
              </li>
              <li>
                {"{info5} - será substituido pela informação complementar 5."}
              </li>
              <li>
                {"{info6} - será substituido pela informação complementar 6."}
              </li>
              <li>
                {"{info7} - será substituido pela informação complementar 7."}
              </li>
              <li>
                {"{info8} - será substituido pela informação complementar 8."}
              </li>
              <li>
                {"{info9} - será substituido pela informação complementar 9."}
              </li>
              <li>
                {"{info10} - será substituido pela informação complementar 10."}
              </li>
              <li>
                {"{info11} - será substituido pela informação complementar 11."}
              </li>
              <li>
                {"{info12} - será substituido pela informação complementar 12."}
              </li>
              <li>
                {"{info13} - será substituido pela informação complementar 13."}
              </li>
              <li>
                {"{info14} - será substituido pela informação complementar 14."}
              </li>
            </div>
          </div>
        </div>

        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function ImpressaoAvulsa() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Sobre Impressão Avulsa</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <span>
          A impressão avulsa é a principal função do iNOVACODE IMPRESSÃO, onde o
          usuário irá realizar a impressão de etiquetas importanto os dados
          diretamente da base INOVAONE.
        </span>
        <span>
          Caso o usuário não tenha cadastrado o elemento na base INOVAONE, o
          elemento será impresso e criado automaticamente na base de dados.
        </span>
        <span>
          A serialização das etiqueta ocorre de forma automatica, onde o usuário
          no ato de gerar o pedido de impressão informa a quantidade de
          etiquetas desejadas.
        </span>
      </div>
    </div>
  );
}

function EPCGS1() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Padrão GS1</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                O padrão GS1 é um conjunto de normas globais usadas para a
                identificação única de produtos, serviços, locais e entidades em
                toda a cadeia de suprimentos.
              </span>
              <span>
                Este sistema facilita o comércio global e a gestão eficiente de
                informações ao longo de toda a cadeia de valor. O padrão GS1 é
                amplamente utilizado em setores como varejo, saúde, transporte e
                logística, entre outros.
              </span>
            </div>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>GTIN:</h3>
              <span>É um identificador único para produtos comerciais.</span>
              <span>
                Facilita a identificação de produtos em pontos de venda e em
                sistemas de inventário.
              </span>
              <span>
                O GTIN é composto por 14 dígitos, sendo os 13 primeiros dígitos
                o GTIN e o último dígito o dígito verificador.
              </span>
              <h3>Exemplo de GTIN GS1:</h3>
              <span>05901234123457</span>
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function EPCPersonalizado() {
  return (
    <div style={{ margin: 8 }}>
      <h1>EPC Personalizado</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                O EPC Personalizado permite que o usuário utilize das
                informações do elemento importado para criar um EPC
                personalizado.
              </span>
            </div>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <h2>Como Montar um EPC Personalizado:</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 1:</h3>
              <span>
                No menu lateral esquerdo localize a sessão "Preferências"
                clique.
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/epc_personalizado_minhaconta.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 2:</h3>
              <span>
                Nas abas superiores clique em "Etiqueta" e em "Tipo de EPC"
                selecione "Personalizado".
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/epc_personalizado_minhaconta_2.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 3:</h3>
              <span>Na direita clique em "Montar EPC"</span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/epc_personalizado_minhaconta_3.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 4:</h3>
              <span>
                Clique e arraste as informações do elemento para montar o EPC.
              </span>
              <span>
                Os EPC são atualizados automaticamente conforme você insere as
                informações.
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/epc_personalizado_minhaconta_4.png"
                width={1000}
              />
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function RealizandoImpressaoAvulsa() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Realizando Impressão Avulsa</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                Para realizar a impressão avulsa siga os seguintes passos:
              </span>
            </div>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 1:</h3>
              <span>Na tela inicial clique em "Impressão Avulsa".</span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_avulsa.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 2:</h3>
              <span>
                Na janela de Impressão Avulsa, selecione a categoria desejada.
              </span>
              <span>
                Caso a categoria não exista é possível criá-la clicando em "Nova
                Categoria"
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_avulsa_2.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 3:</h3>
              <span>
                Ao selecionar a categoria, digite a quantidade e verifique os
                EPCS.
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_avulsa_3.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 4:</h3>
              <span>Clique em imprimir e aguarde a impressão.</span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_avulsa_4.png"
                width={1000}
              />
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function OrdensDeImpressao() {
  return (
    <div>
      <h1>Sobre Ordens de Impressão</h1>
      <p>
        As ordens de impressão são utilizadas para agrupar etiquetas e facilitar
        a impressão de várias etiquetas de uma só vez.
      </p>
    </div>
  );
}

function ComoConfigurarCampos() {
  return (
    <div>
      <h1>Como Configurar Campos</h1>
      <p>
        Para configurar os campos de uma ordem de impressão, siga os seguintes
        passos:
      </p>
    </div>
  );
}

function ImpressaoOFREF() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Sobre Impressão OF/REF</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                O EPC Personalizado permite que o usuário utilize das
                informações do elemento importado para criar um EPC
                personalizado.
              </span>
            </div>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <h2>Como Importar Pedidos (OF Externas):</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 1:</h3>
              <span>Na tela inicial clique em "Importar Pedido".</span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressaoofref.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 2:</h3>
              <span>
                Na janela de Importar Pedido, preencha com o código do pedido
                (ou selecione na lista abaixo no caso de pedidos diretos do
                Inovaone) e clique em Pesquisar OF
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressaoofref_2.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 3:</h3>
              <span>
                Após selecionar o item desejado, preencha com as quantidades
                para cada categoria do pedido, e clique em imprimir.
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressaoofref_3.png"
                width={1000}
              />
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function ImpressaoUSB() {
  return (
    <div style={{ margin: 8 }}>
      <h1>Sobre Impressão USB</h1>
      <div style={{ gap: 16, display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <span>
                É possivel realizar impressões via USB diretamente de uma
                impressora Zebra conectado ao computador.
              </span>
              <span style={{ fontWeight: "bold" }}>
                Ainda não é possivel realizar impressões USB com a impressora
                Sato.
              </span>
            </div>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <h2>Como realizar uma impressão USB:</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 1:</h3>
              <span>
                Baixe o software Zebra Browser Print e faça a instalação no seu
                computador.
              </span>
              <a href="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/zebra-browser-print-windows.exe">
                Clique aqui para baixar.
              </a>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_usb.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 2:</h3>
              <span>
                Calibre sua impressora, conecte o cabo USB no computador e no
                software, na sessão "Default Devices" clique em "Change".
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_usb_2.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 3:</h3>
              <span>
                Quando esta janela aparecer, selecione a impressora desejada e
                clique em "Set".
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_usb_3.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 4:</h3>
              <span>
                No iNOVACODE IMPRESSÃO, clique em "Minha Conta" e selecione a
                opção "Sim" em "Impressão USB".
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_usb_5.png"
                width={1000}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <h3>Passo 5:</h3>
              <span>
                Ao realizar a impressão pela primeira vez, clique em "Sim" para
                que o navegador possa acessar a impressora.
              </span>
              <img
                style={{ border: "1px solid #c2c2c2" }}
                src="https://inovacodefirmup.s3.sa-east-1.amazonaws.com/Outros/documentacao_fotos/impressao_usb_4.png"
                width={1000}
              />
            </div>
          </div>
        </div>
        <div style={{ margin: 16 }} />
      </div>
    </div>
  );
}

function ImportarPlanilha() {
  return (
    <div>
      <h1>Sobre Importar Planilha</h1>
      <p>
        A importação de planilha é utilizada para importar dados de uma planilha
        para a impressão de etiquetas.
      </p>
    </div>
  );
}

function MinhaConta() {
  return (
    <div>
      <h1>Sobre Minha Conta</h1>
      <p>
        A página Minha Conta é utilizada para visualizar e editar as informações
        da conta do usuário.
      </p>
    </div>
  );
}

function SobreAPIExterna() {
  return (
    <div>
      <h1>O que é API Externa?</h1>
      <p>
        A API Externa é utilizada para integrar o iNOVACODE IMPRESSÃO com outros
        sistemas.
      </p>
    </div>
  );
}

function DicionarioDeErros() {
  return (
    <div>
      <h1>Dicionário de Erros</h1>
      <h3>
        Se qualquer um desses erros acontecerem com frequencia, recomenda-se
        acionar os desenvolvedores.
      </h3>
      <p>
        Erro ao coletar categorias: A API tentou requisitar as categorias do
        INOVAONE/ERP, mas não obteve sucesso, recomenda-se atualizar a página
        (F5).
      </p>
      <p>
        Erro ao coletar item: A API tentou requisitar o item do INOVAONE/ERP,
        mas não obteve sucesso, recomenda-se atualizar a página (F5).
      </p>
      <p>
        Erro ao subir item para [sisplan]: O sistema não conseguiu subir o item
        para o sisplan, recomenda-se verificar se está tudo correto com o item
        ou conexão com o erp.
      </p>
      <p>
        Tipo de retorno não definido: O sistema não conseguiu identificar o tipo
        de retorno definido para o sisplan, recomenda-se verificar se foi
        selecionado o retorno "M" (MATERIAL) ou "P" (PEDIDO).
      </p>
      <p>
        Erro ao subir item para [bling]: O sistema não conseguiu subir o item
        para o bling, recomenda-se verificar se está tudo correto com o item ou
        conexão com o erp.
      </p>
      <p>
        Erro ao criar nova localização nivel 1/2/3/4: O sistema não conseguiu
        criar a localização nivel 1, recomenda-se verificar se está tudo correto
        com a localização ou se a API esta funcionando corretamente.
      </p>
      <p>
        Erro ao criar nova categoria: O sistema não conseguiu criar a categoria,
        recomenda-se verificar se está tudo correto com a categoria ou se a API
        esta funcionando corretamente.
      </p>
      <p>
        Erro ao adicionar serial. O sistema não conseguiu adicionar o serial na
        base, recomenda-se verificar se está tudo correto com o serial ou se a
        API esta funcionando corretamente.
      </p>
      <p>
        Erro ao salvar etiquetas: O sistema não conseguiu salvar as etiquetas na
        base, recomenda-se verificar se está tudo correto com as etiquetas
        (verificar duplicidade) ou se a API esta funcionando corretamente.
      </p>
      <p>
        Erro ao coletar etiquetas: O sistema não conseguiu coletar a lista de
        ZPLs da conta, recomenda-se criar um ZPL para a conta, se o erro
        persistir, acionar os desenvolvedores.
      </p>
      <p>
        Erro ao coletar GTINs: O sistema não conseguiu solicitar a lista de
        serialização da API, recomenda-se atualizar a página (F5), se o erro
        persistir, acionar os desenvolvedores.
      </p>
    </div>
  );
}

function SobreHardwareID() {
  return (
    <div>
      <h1>O que é Hardware ID?</h1>
      <p>
        O Hardware ID é utilizado para identificar o dispositivo que está
        utilizando o iNOVACODE IMPRESSÃO.
      </p>
    </div>
  );
}

function SobreForca() {
  return (
    <div>
      <h1>O que é Força?</h1>
      <p>
        A Força é utilizada para definir a intensidade da gravação de etiquetas
        RFID.
      </p>
    </div>
  );
}

function SobreTempoDelayGravacao() {
  return (
    <div>
      <h1>O que é Tempo Delay Gravação?</h1>
      <p>
        O Tempo Delay Gravação é utilizado para definir o tempo de espera entre
        a gravação de etiquetas RFID.
      </p>
    </div>
  );
}

function Documentacao() {
  const [children, setChildren] = useState(<Introducao />);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedSubIndex, setSelectedSubIndex] = useState(-1);

  const sessoesMenu = [
    { nome: "Introdução", children: <Introducao /> },
    {
      nome: "Sobre Etiquetas",
      children: <Etiquetas />,
      topicos: [
        { nome: "Como criar uma etiqueta", children: <CriarEtiqueta /> },
        { nome: "Como editar uma etiqueta", children: <EditarEtiqueta /> },
        {
          nome: "Como definir etiqueta padrão",
          children: <DefinirEtiquetaPadrao />,
        },
        { nome: "Como apagar uma etiqueta", children: <ApagarEtiqueta /> },
        { nome: "O que significa RFW?", children: <RFW /> },
        {
          nome: "Váriaveis de substituição",
          children: <VariaveisDeInformacoes />,
        },
      ],
    },

    {
      nome: "Sobre Impressão Avulsa",
      children: <ImpressaoAvulsa />,
      topicos: [
        { nome: "Padrão GS1", children: <EPCGS1 /> },
        { nome: "EPC Personalizado", children: <EPCPersonalizado /> },
        {
          nome: "Realizando Impressão Avulsa",
          children: <RealizandoImpressaoAvulsa />,
        },
      ],
    },
    {
      nome: "Sobre Ordens de Impressão",
      children: <OrdensDeImpressao />,
      topicos: [
        { nome: "Como configurar campos", children: <ComoConfigurarCampos /> },
      ],
    },
    {
      nome: "Sobre Impressão OF/REF",
      children: <ImpressaoOFREF />,
    },
    {
      nome: "Sobre Impressão USB",
      children: <ImpressaoUSB />,
    },
    { nome: "Sobre Importar Planilha", children: <ImportarPlanilha /> },
    {
      nome: "Sobre Minha Conta",
      children: <MinhaConta />,
      topicos: [
        { nome: "O que é API Externa?", children: <SobreAPIExterna /> },
        { nome: "O que é Hardware ID?", children: <SobreHardwareID /> },
        { nome: "O que é Força?", children: <SobreForca /> },
        {
          nome: "O que é Tempo Delay Gravação?",
          children: <SobreTempoDelayGravacao />,
        },
      ],
    },
    {
      nome: "Sobre Erros",
      children: <MinhaConta />,
      topicos: [
        { nome: "Dicionário de erros", children: <DicionarioDeErros /> },
      ],
    },
  ];

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div className="w-80 border-r bg-background">
        <ScrollArea className="h-[calc(100vh-200px)]">
          <div className="p-4">
            {sessoesMenu.map((sessao, index) => (
              <div key={index} className="mb-2">
                <Button
                  variant={selectedIndex === index ? "secondary" : "ghost"}
                  className={cn(
                    "w-full justify-start gap-2",
                    selectedIndex === index && "font-semibold",
                  )}
                  onClick={() => {
                    setSelectedIndex(index);
                    setSelectedSubIndex(-1);
                    setChildren(sessao.children);
                  }}
                >
                  <span>{index + 1}.</span>
                  <span>{sessao.nome}</span>
                  <ArrowRight className="h-4 w-4 ml-auto" />
                </Button>

                {sessao.topicos && selectedIndex === index && (
                  <div className="ml-4 mt-1 space-y-1">
                    {sessao.topicos.map((topico, subIndex) => (
                      <Button
                        key={subIndex}
                        variant={
                          selectedSubIndex === subIndex ? "secondary" : "ghost"
                        }
                        className={cn(
                          "w-full justify-start text-sm gap-2",
                          selectedSubIndex === subIndex && "font-semibold",
                        )}
                        onClick={() => {
                          setSelectedSubIndex(subIndex);
                          setChildren(topico.children);
                        }}
                      >
                        <span>
                          {index + 1}.{subIndex + 1}.
                        </span>
                        <span>{topico.nome}</span>
                        <ArrowRight className="h-4 w-4 ml-auto" />
                      </Button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>

      {/* Main Content */}
      <ScrollArea className="flex-1">
        <div className="p-6">
          <div className="max-w-4xl mx-auto prose prose-slate">{children}</div>
        </div>
      </ScrollArea>
    </div>
  );
}

export default Documentacao;
